import { HttpClient,HttpHeaders } from "@angular/common/http"; 
import { inject, Injectable } from "@angular/core"; 
import { HospitalDashboardKPIRequestDTO, HospitalUserAffiliationCreateBulkRequestDTO, HospitalStaffBulkResultList, HospitalUserAffiliationCreateRequestDTO, HospitalUserAffiliationDeleteRequestDTO, HospitalUserAffiliationDoctorGetDictionaryRequestDTO, HospitalUserAffiliationDoctorGetDictionaryResponseDTO, HospitalUserAffiliationDTO, HospitalUserAffiliationList, hospitalUserAffiliationReadByHospitalIdRequestDTO, HospitalUserAffiliationReadByIdRequestDTO, HospitalUserAffiliationReadByUserIdRequestDTO, HospitalUserAffiliationReadUserByHospitalIdRequestDTO, HospitalUserAffiliationReadUserBySearchTermRequestDTO, HospitalUserAffiliationUpdateRequestDTO, ReadAllPaginatedRequestDTO } from "./user-affiliation-mapping.interface"; 
import { Observable } from "rxjs"; 
import { HospitalUserAffiliation_Create, HospitalUserAffiliation_Create_External, HospitalUserAffiliation_Delete,HospitalUserAffiliation_UpdateExternal, HospitalUserAffiliation_DoctorGetDictonary, HospitalUserAffiliation_ReadAll, HospitalUserAffiliation_ReadByHospitalId, HospitalUserAffiliation_ReadById, HospitalUserAffiliation_ReadByIdExternal, HospitalUserAffiliation_ReadByUserId, HospitalUserAffiliation_Update, HosptialUserAffiliation_HospitalDashboardKPI, HosptialUserAffiliation_ReadAllPaginated, HosptialUserAffiliation_ReadUserByHospitalId, HosptialUserAffiliation_ReadUserBySearchTerm } from "src/app/GlobalVariable/Hospital.GlobalVariable"; 
import { AttendanceSchoolReadAllPaginatedRequestDTO, AttendanceSchoolReadAllPaginatedResponseDTO, AttendanceSchoolStaffAttendanceKPIRequestDTO, AttendanceSchoolStaffAttendanceKPIResponseDTO } from "src/app/School/SchoolUserMapping/user-affiliation-mapping.interface"; 
import { Attendance_SchoolReadAllPaginated, Attendance_SchoolStaffAttendanceKPI, HospitalUserAffiliation_CreateBulk } from "src/app/GlobalVariable"; 
 
@Injectable({ 
    providedIn: 'root', 
}) 
 
export class HospitalUserAffiliationService { 
    http = inject(HttpClient); 
 
    HospitalUserAffiliationCreate(data: HospitalUserAffiliationCreateRequestDTO): Observable<HospitalUserAffiliationDTO>{ 
        return this.http.post<HospitalUserAffiliationDTO>(HospitalUserAffiliation_Create, data); 
    }; 

    HospitalUserAffiliationCreate_External(
      data: HospitalUserAffiliationCreateRequestDTO,
      xApiKey: string,
      xApiTimestamp: string,
      xApiNonce: string,
      xApiSignature: string
    ): Observable<HospitalUserAffiliationDTO> {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'X-Api-Key': xApiKey,
        'X-Api-Timestamp': xApiTimestamp,
        'X-Api-Nonce': xApiNonce,
        'X-Api-Signature': xApiSignature
      });
      return this.http.post<HospitalUserAffiliationDTO>(HospitalUserAffiliation_Create_External, data, { headers });
    }

    // ============================================================
    // BULK STAFF / DOCTOR CREATE
    // POST /H/UAM/CreateBulk
    // ============================================================
    HospitalUserAffiliationCreateBulk(
      data: HospitalUserAffiliationCreateBulkRequestDTO,
    ): Observable<HospitalStaffBulkResultList> {
      return this.http.post<HospitalStaffBulkResultList>(
        HospitalUserAffiliation_CreateBulk,
        data,
      );
    }
 
    HospitalUserAffiliationUpdate(data: HospitalUserAffiliationUpdateRequestDTO): Observable<HospitalUserAffiliationDTO> { 
        return this.http.post<HospitalUserAffiliationDTO>(HospitalUserAffiliation_Update, data); 
    }; 
    // HospitalUserAffiliationUpdate_External(data: HospitalUserAffiliationUpdateRequestDTO): Observable<HospitalUserAffiliationDTO> { 
    //     return this.http.post<HospitalUserAffiliationDTO>(HospitalUserAffiliation_UpdateExternal, data); 
    // }; 
 
    HospitalUserAffiliationReadAll():Observable<HospitalUserAffiliationList> { 
        return this.http.get<HospitalUserAffiliationList>(HospitalUserAffiliation_ReadAll); 
    }; 
 
    HospitalUserAffiliationReadById(data: HospitalUserAffiliationReadByIdRequestDTO):Observable<HospitalUserAffiliationDTO> { 
        return this.http.post<HospitalUserAffiliationDTO>(HospitalUserAffiliation_ReadById, data); 
    }; 
    // HospitalUserAffiliationReadById_External(data: HospitalUserAffiliationReadByIdRequestDTO):Observable<HospitalUserAffiliationDTO> { 
    // return this.http.post<HospitalUserAffiliationDTO>(HospitalUserAffiliation_ReadByIdExternal, data); 
    // }; 
 
    HospitalUserAffiliationReadByHospitalId(data: hospitalUserAffiliationReadByHospitalIdRequestDTO): Observable<HospitalUserAffiliationList> { 
        return this.http.post<HospitalUserAffiliationList>(HospitalUserAffiliation_ReadByHospitalId, data); 
    }; 
 
    HospitalUserAffiliationReadByUserId(data: HospitalUserAffiliationReadByUserIdRequestDTO) : Observable<HospitalUserAffiliationList>{ 
        return this.http.post<HospitalUserAffiliationList>(HospitalUserAffiliation_ReadByUserId, data); 
    }; 
 
    HospitalUserAffliationDelete(data: HospitalUserAffiliationDeleteRequestDTO): Observable<void>{ 
        return this.http.post<void>(HospitalUserAffiliation_Delete, data); 
    }; 
 
    HostpitalUserAffiliationDoctorGetDictionary(data: HospitalUserAffiliationDoctorGetDictionaryRequestDTO): Observable<HospitalUserAffiliationDoctorGetDictionaryResponseDTO> { 
        return this.http.post<HospitalUserAffiliationDoctorGetDictionaryResponseDTO>(HospitalUserAffiliation_DoctorGetDictonary, data); 
    } 
 
    HospitalUserAffiliationReadUserByHospitalId(data: HospitalUserAffiliationReadUserByHospitalIdRequestDTO) : Observable<HospitalUserAffiliationList> { 
        return this.http.post<HospitalUserAffiliationList>(HosptialUserAffiliation_ReadUserByHospitalId, data); 
    } 
 
    HosptialUserAffiliationReadUserBySearchTerm(data: HospitalUserAffiliationReadUserBySearchTermRequestDTO) : Observable<HospitalUserAffiliationList> { 
        return this.http.post<HospitalUserAffiliationList>(HosptialUserAffiliation_ReadUserBySearchTerm, data); 
    } 
 
    HosptialUserAffiliation_HospitalDashboardKPI(data: HospitalDashboardKPIRequestDTO) : Observable<HospitalUserAffiliationList> { 
        return this.http.post<HospitalUserAffiliationList>(HosptialUserAffiliation_HospitalDashboardKPI, data); 
    } 
 
    HosptialUserAffiliation_ReadAllPaginated(data: ReadAllPaginatedRequestDTO): Observable<HospitalUserAffiliationList> { 
    return this.http.post<HospitalUserAffiliationList>(HosptialUserAffiliation_ReadAllPaginated, data); 
} 
 
 
Attendance_SchoolStaffAttendanceKPI( 
  data: AttendanceSchoolStaffAttendanceKPIRequestDTO, 
): Observable<AttendanceSchoolStaffAttendanceKPIResponseDTO> { 
  return this.http.post<AttendanceSchoolStaffAttendanceKPIResponseDTO>( 
    Attendance_SchoolStaffAttendanceKPI, 
    data, 
  ); 
} 
 
 
Attendance_SchoolReadAllPaginated( 
  data: AttendanceSchoolReadAllPaginatedRequestDTO, 
): Observable<AttendanceSchoolReadAllPaginatedResponseDTO> { 
  return this.http.post<AttendanceSchoolReadAllPaginatedResponseDTO>( 
    Attendance_SchoolReadAllPaginated, 
    data, 
  ); 
} 
 
HospitalUserAffiliationUpdate_External( 
  data: HospitalUserAffiliationUpdateRequestDTO, 
  xApiKey: string, 
  xApiTimestamp: string, 
  xApiNonce: string, 
  xApiSignature: string 
): Observable<HospitalUserAffiliationDTO> { 
 
  const headers = new HttpHeaders({ 
    'Content-Type': 'application/json', 
    'X-Api-Key': xApiKey, 
    'X-Api-Timestamp': xApiTimestamp, 
    'X-Api-Nonce': xApiNonce, 
    'X-Api-Signature': xApiSignature 
  }); 
 
  return this.http.post<HospitalUserAffiliationDTO>( 
    HospitalUserAffiliation_UpdateExternal, 
    data, 
    { headers } 
  ); 
} 
 
HospitalUserAffiliationReadById_External( 
  data: HospitalUserAffiliationReadByIdRequestDTO, 
  xApiKey: string, 
  xApiTimestamp: string, 
  xApiNonce: string, 
  xApiSignature: string 
): Observable<HospitalUserAffiliationDTO> { 
 
  const headers = new HttpHeaders({ 
    'Content-Type': 'application/json', 
    'X-Api-Key': xApiKey, 
    'X-Api-Timestamp': xApiTimestamp, 
    'X-Api-Nonce': xApiNonce, 
    'X-Api-Signature': xApiSignature 
  }); 
 
  return this.http.post<HospitalUserAffiliationDTO>( 
    HospitalUserAffiliation_ReadByIdExternal, 
    data, 
    { headers } 
  ); 
} 
 
} 
